import type React from 'react';
import classNames from 'classnames';
import Icon from '../../../stories/Atoms/Icon/Icon';
import styles from './Faq.module.scss';

export interface QuestionProps {
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
  question: string;
}

const Question: React.FC<QuestionProps> = ({
  answer,
  isOpen,
  onToggle,
  question,
}) => (
  <div
    data-testid="faq-question"
    className={classNames(styles.Faq, {
      [styles.Faq_opened as string]: isOpen,
    })}
  >
    <button
      className={styles.Faq__question}
      onClick={onToggle}
      type="button"
    >
      <span>{question}</span>
      <Icon
        name={isOpen ? 'fa-minus' : 'fa-plus'}
        className={styles.Faq__question__icon}
      />
    </button>
    <div className={classNames(styles.Faq__answer)}>
      <div
        className="faq-answer faq-answer--toggle"
        dangerouslySetInnerHTML={{ __html: answer }}
      />
    </div>
  </div>
);

export default Question;
